// #region Imports
import { motion } from "framer-motion";
// #endregion


function Stars() {

	return (
		<aside
			className="
				w-screen h-screen
				absolute top-0 z-0
				overflow-clip opacity-80
			"
		>

			<div
				className="
					relative flex flex-col
					items-center justify-center
					w-full h-full
				"
			>

				{/* 60VH ORBIT */}

				<motion.span
					className="
						absolute top-28 left-24
						small:top-32 small:-left-20
						rounded-full
						w-[60vh] h-[60vh]
						border-[0.75px] border-grey
						z-0
					"
					animate={{
						rotate: [90, 180, 270, 360, 405, 450],
					}}
					transition={{
						repeat: Infinity,
						ease: "easeInOut",
						duration: 10,
						delay: 0.4,
					}}
				>

					<img
						className="
							absolute
							top-1/2 right-0
							-translate-y-1/2
							translate-x-1/2
							w-[4vh] h-[4vh]
						"
						fetchPriority="high"
						alt="Star"
						src="/icons/darkStar.svg"
					/>

				</motion.span>


				{/* 80VH ORBIT — BACKGROUND */}

				<span
					className="
						absolute top-16 left-16
						rounded-full
						w-[80vh] h-[80vh]
						border-[0.75px] border-grey
						blur-[1px]
						z-0
						small:hidden
					"
				/>


				{/* 90VH ORBIT — BACKGROUND */}

				<span
					className="
						absolute top-8 left-12
						small:top-24 small:-left-32
						rounded-full
						w-[90vh] h-[90vh]
						small:w-[80vh] small:h-[80vh]
						border-[0.75px] border-grey
						z-0
					"
				/>


				{/* 120VH ORBIT */}

				<motion.span
					className="
						absolute -top-10 left-4
						small:top-12 small:-left-64
						rounded-full
						w-[120vh] h-[120vh]
						border-[0.75px] border-grey
						z-0
					"
					animate={{
						rotate: [90, 180, 270, 360, 405, 450],
					}}
					transition={{
						repeat: Infinity,
						ease: "easeInOut",
						duration: 10,
						delay: 1.4,
					}}
				>

					<img
						className="
							absolute
							top-1/2 right-0
							-translate-y-1/2
							translate-x-1/2
							w-[7vh] h-[7vh]
						"
						fetchPriority="high"
						alt="Star"
						src="/icons/darkStar.svg"
					/>

				</motion.span>


				{/* 140VH ORBIT */}

				<motion.span
					className="
						absolute -top-28 left-0
						rounded-full
						w-[140vh] h-[140vh]
						border-[0.75px] border-grey
						z-0
						small:hidden
					"
					animate={{
						rotate: [90, 180, 270, 360, 405, 450],
					}}
					transition={{
						repeat: Infinity,
						ease: "easeInOut",
						duration: 10,
						delay: 2.4,
					}}
				>

					<img
						className="
							absolute
							top-1/2 right-0
							-translate-y-1/2
							translate-x-1/2
							w-[8vh] h-[8vh]
						"
						fetchPriority="high"
						alt="Star"
						src="/icons/darkStar.svg"
					/>

				</motion.span>

			</div>

		</aside>
	);
}


export default Stars;